export enum EMeasureReferenceType {
    None = 0,
    Gax = 1,
    FDX,
    HorsFDX,
}
